import { genericGet } from "../../../utils/genericApiCall";

export async function obtenerInstituciones() {
    const url_endpoint = '/InstitucionSalud/ObtenerTodos';
    const message_info = 'Obteniendo instituciones de salud...';
    const message_error = 'Error al obtener instituciones de salud...';

    return await genericGet({
        url_endpoint: url_endpoint, 
        message_info: message_info, 
        message_error: message_error
    });
}